// Grace window before the offline modal appears. A dropped socket, or a tab
// returning from the background (Zero disconnects hidden tabs), gets this long
// to reconnect before we tell the user anything is wrong.
export const OFFLINE_GRACE_MS = 5000

export interface OfflineVisibilityState {
	connectionDown: boolean
	graceElapsed: boolean
}

export type OfflineVisibilityEvent =
	| { type: "connection-changed"; down: boolean }
	| { type: "tab-visible" }
	| { type: "grace-elapsed" }

export const initialOfflineVisibility: OfflineVisibilityState = {
	connectionDown: false,
	graceElapsed: false,
}

export function offlineVisibilityReducer(
	state: OfflineVisibilityState,
	event: OfflineVisibilityEvent,
): OfflineVisibilityState {
	switch (event.type) {
		case "connection-changed":
			if (!event.down) return initialOfflineVisibility
			if (state.connectionDown) return state
			return { connectionDown: true, graceElapsed: false }
		case "tab-visible":
			if (!state.connectionDown) return state
			return { connectionDown: true, graceElapsed: false }
		case "grace-elapsed":
			if (!state.connectionDown) return state
			return { connectionDown: true, graceElapsed: true }
	}
}

export function shouldShowOfflineModal(state: OfflineVisibilityState): boolean {
	return state.connectionDown && state.graceElapsed
}
